import { Outlet } from 'react-router-dom'

import { PageApp } from '@/Shared/ui/navigation'

export const AppLayout = (): JSX.Element => {
  return (
    <PageApp>
      <Outlet />
    </PageApp>
  )
}
